"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCard = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardMixin = require("../../mixins/components/PropertyCardMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledPropertyCard = /*#__PURE__*/_styledComponents.default.article.withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['loading'])
}).withConfig({
  displayName: "StyledPropertyCard",
  componentId: "c11n-8-107-0__sc-g2ckw9-0"
})(["", ""], _PropertyCardMixin.PropertyCardMixin);
exports.StyledPropertyCard = StyledPropertyCard;